// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/Site/Declaracao/Declaracao.module.css */
.Declaracao_contentContainer__yWbiC {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 100px;
}

.Declaracao_accordionMenu__AlwuA {
    display: inline-block;
    position: relative;
    margin-top: 10vh;
    max-width: 800px;
    padding: 10px 20px 20px;
    border-radius: 5px;
}

.Declaracao_accordionMenuButton__3ru9L {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    background-color: #00a0e4;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s, transform 0.2s;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    margin-right: 10px;
}

.Declaracao_accordionMenuButton__3ru9L:hover {
    background-color: #0090d9;
    transform: scale(1.05);
}

.Declaracao_accordionMenuButton__3ru9L:active {
    background-color: #007bb5;
    transform: scale(0.98);
}

.Declaracao_accordionMenuButtons__J40CR {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
}

.Declaracao_accordionMenuButtons__J40CR.Declaracao_topButtons__ZdjYS {
    margin-bottom: 20px;
}

.Declaracao_accordionMenuButtons__J40CR.Declaracao_bottomButtons__nO2xa {
    margin-top: 20px;
}

.Declaracao_accordionMenu__AlwuA h2 {
    font-size: 18px;
    line-height: 34px;
    font-weight: 500;
    letter-spacing: 1px;
    display: block;
    margin: 0;
    cursor: pointer;
    color: #000;
}

.Declaracao_accordionMenu__AlwuA p {
    color: rgba(48, 69, 92, 0.8);
    font-size: 15px;
    line-height: 26px;
    letter-spacing: 1px;
    margin-top: 14px;
}

.Declaracao_accordionMenu__AlwuA ul {
    list-style: none;
    padding: 0 20px 10px;
    margin: 0;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.375),
        0 2px 2px rgba(0, 0, 0, 0.185);
}

.Declaracao_accordionMenu__AlwuA ul li {
    position: relative;
    padding: 0;
    margin: 0;
    padding-bottom: 4px;
    padding-top: 18px;
    border-top: 1px outset #00000059;
}

.Declaracao_accordionMenu__AlwuA ul li p {
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    transition: max-height 0.3s ease, opacity 0.3s ease, transform 0.3s ease;
}

.Declaracao_accordionMenu__AlwuA ul li:first-child {
    border-top: none;
}

.Declaracao_accordionMenu__AlwuA ul li .Declaracao_arrow__Jq1ca {
    position: absolute;
    transform: translate(-6px, 0);
    margin-top: 16px;
    right: 0;
}

.Declaracao_accordionMenu__AlwuA ul li .Declaracao_fas__7s9UA {
    color: #1e1e1e;
    font-size: 15px;
    margin-right: 10px;
}

.Declaracao_accordionMenu__AlwuA ul li .Declaracao_arrow__Jq1ca:before,
.Declaracao_accordionMenu__AlwuA ul li .Declaracao_arrow__Jq1ca:after {
    content: "";
    position: absolute;
    background-color: #1e1e1e;
    width: 3px;
    height: 9px;
}

.Declaracao_accordionMenu__AlwuA ul li .Declaracao_arrow__Jq1ca:before {
    transform: translate(-2px, 0) rotate(-45deg);
}

.Declaracao_accordionMenu__AlwuA ul li .Declaracao_arrow__Jq1ca:after {
    transform: translate(2px, 0) rotate(45deg);
}

.Declaracao_accordionMenu__AlwuA ul li input[type=checkbox] {
    position: absolute;
    cursor: pointer;
    width: 100%;
    height: 100%;
    z-index: 1;
    opacity: 0;
}

.Declaracao_accordionMenu__AlwuA ul li input[type=checkbox]:checked~p {
    max-height: 500px;
    opacity: 1;
    transform: translate(0, 0);
    transition: max-height 0.3s ease, opacity 0.3s ease, transform 0.3s ease;
}

.Declaracao_accordionMenu__AlwuA ul li input[type=checkbox]:checked~.Declaracao_arrow__Jq1ca:before {
    transform: translate(2px, 0) rotate(-45deg);
}

.Declaracao_accordionMenu__AlwuA ul li input[type=checkbox]:checked~.Declaracao_arrow__Jq1ca:after {
    transform: translate(-2px, 0) rotate(45deg);
}

.Declaracao_flipIn__sDhaN,
h1,
ul li {
    animation: Declaracao_flipdown__mu-EN 0.5s ease both;
}

.Declaracao_no-select__iGcah,
h2 {
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
            user-select: none;
}

@keyframes Declaracao_flipdown__mu-EN {
    0% {
        opacity: 0;
        transform-origin: top center;
        transform: rotateX(-90deg);
    }

    5% {
        opacity: 1;
    }

    80% {
        transform: rotateX(8deg);
    }

    83% {
        transform: rotateX(6deg);
    }

    92% {
        transform: rotateX(-3deg);
    }

    100% {
        transform-origin: top center;
        transform: rotateX(0deg);
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Site/SobreNos/Declaracao/Declaracao.module.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,iDAAiD;IACjD,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,SAAS;IACT,sBAAsB;IACtB,kBAAkB;IAClB;sCACkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,wEAAwE;AAC5E;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,UAAU;IACV,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,0BAA0B;IAC1B,wEAAwE;AAC5E;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;;;IAGI,oDAAkC;AACtC;;AAEA;;IAEI,wCAAwC;IACxC,2BAA2B;IAC3B,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;QAC5B,0BAA0B;IAC9B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,4BAA4B;QAC5B,wBAAwB;IAC5B;AACJ","sourcesContent":["/* src/pages/Site/Declaracao/Declaracao.module.css */\r\n.contentContainer {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-top: 30px;\r\n    margin-bottom: 100px;\r\n}\r\n\r\n.accordionMenu {\r\n    display: inline-block;\r\n    position: relative;\r\n    margin-top: 10vh;\r\n    max-width: 800px;\r\n    padding: 10px 20px 20px;\r\n    border-radius: 5px;\r\n}\r\n\r\n.accordionMenuButton {\r\n    padding: 10px 20px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    background-color: #00a0e4;\r\n    color: #fff;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s, transform 0.2s;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n    margin-right: 10px;\r\n}\r\n\r\n.accordionMenuButton:hover {\r\n    background-color: #0090d9;\r\n    transform: scale(1.05);\r\n}\r\n\r\n.accordionMenuButton:active {\r\n    background-color: #007bb5;\r\n    transform: scale(0.98);\r\n}\r\n\r\n.accordionMenuButtons {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.accordionMenuButtons.topButtons {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.accordionMenuButtons.bottomButtons {\r\n    margin-top: 20px;\r\n}\r\n\r\n.accordionMenu h2 {\r\n    font-size: 18px;\r\n    line-height: 34px;\r\n    font-weight: 500;\r\n    letter-spacing: 1px;\r\n    display: block;\r\n    margin: 0;\r\n    cursor: pointer;\r\n    color: #000;\r\n}\r\n\r\n.accordionMenu p {\r\n    color: rgba(48, 69, 92, 0.8);\r\n    font-size: 15px;\r\n    line-height: 26px;\r\n    letter-spacing: 1px;\r\n    margin-top: 14px;\r\n}\r\n\r\n.accordionMenu ul {\r\n    list-style: none;\r\n    padding: 0 20px 10px;\r\n    margin: 0;\r\n    background-color: #fff;\r\n    border-radius: 5px;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.375),\r\n        0 2px 2px rgba(0, 0, 0, 0.185);\r\n}\r\n\r\n.accordionMenu ul li {\r\n    position: relative;\r\n    padding: 0;\r\n    margin: 0;\r\n    padding-bottom: 4px;\r\n    padding-top: 18px;\r\n    border-top: 1px outset #00000059;\r\n}\r\n\r\n.accordionMenu ul li p {\r\n    max-height: 0;\r\n    overflow: hidden;\r\n    opacity: 0;\r\n    transition: max-height 0.3s ease, opacity 0.3s ease, transform 0.3s ease;\r\n}\r\n\r\n.accordionMenu ul li:first-child {\r\n    border-top: none;\r\n}\r\n\r\n.accordionMenu ul li .arrow {\r\n    position: absolute;\r\n    transform: translate(-6px, 0);\r\n    margin-top: 16px;\r\n    right: 0;\r\n}\r\n\r\n.accordionMenu ul li .fas {\r\n    color: #1e1e1e;\r\n    font-size: 15px;\r\n    margin-right: 10px;\r\n}\r\n\r\n.accordionMenu ul li .arrow:before,\r\n.accordionMenu ul li .arrow:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    background-color: #1e1e1e;\r\n    width: 3px;\r\n    height: 9px;\r\n}\r\n\r\n.accordionMenu ul li .arrow:before {\r\n    transform: translate(-2px, 0) rotate(-45deg);\r\n}\r\n\r\n.accordionMenu ul li .arrow:after {\r\n    transform: translate(2px, 0) rotate(45deg);\r\n}\r\n\r\n.accordionMenu ul li input[type=checkbox] {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 1;\r\n    opacity: 0;\r\n}\r\n\r\n.accordionMenu ul li input[type=checkbox]:checked~p {\r\n    max-height: 500px;\r\n    opacity: 1;\r\n    transform: translate(0, 0);\r\n    transition: max-height 0.3s ease, opacity 0.3s ease, transform 0.3s ease;\r\n}\r\n\r\n.accordionMenu ul li input[type=checkbox]:checked~.arrow:before {\r\n    transform: translate(2px, 0) rotate(-45deg);\r\n}\r\n\r\n.accordionMenu ul li input[type=checkbox]:checked~.arrow:after {\r\n    transform: translate(-2px, 0) rotate(45deg);\r\n}\r\n\r\n.flipIn,\r\nh1,\r\nul li {\r\n    animation: flipdown 0.5s ease both;\r\n}\r\n\r\n.no-select,\r\nh2 {\r\n    -webkit-tap-highlight-color: transparent;\r\n    -webkit-touch-callout: none;\r\n    user-select: none;\r\n}\r\n\r\n@keyframes flipdown {\r\n    0% {\r\n        opacity: 0;\r\n        transform-origin: top center;\r\n        transform: rotateX(-90deg);\r\n    }\r\n\r\n    5% {\r\n        opacity: 1;\r\n    }\r\n\r\n    80% {\r\n        transform: rotateX(8deg);\r\n    }\r\n\r\n    83% {\r\n        transform: rotateX(6deg);\r\n    }\r\n\r\n    92% {\r\n        transform: rotateX(-3deg);\r\n    }\r\n\r\n    100% {\r\n        transform-origin: top center;\r\n        transform: rotateX(0deg);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentContainer": `Declaracao_contentContainer__yWbiC`,
	"accordionMenu": `Declaracao_accordionMenu__AlwuA`,
	"accordionMenuButton": `Declaracao_accordionMenuButton__3ru9L`,
	"accordionMenuButtons": `Declaracao_accordionMenuButtons__J40CR`,
	"topButtons": `Declaracao_topButtons__ZdjYS`,
	"bottomButtons": `Declaracao_bottomButtons__nO2xa`,
	"arrow": `Declaracao_arrow__Jq1ca`,
	"fas": `Declaracao_fas__7s9UA`,
	"flipIn": `Declaracao_flipIn__sDhaN`,
	"flipdown": `Declaracao_flipdown__mu-EN`,
	"no-select": `Declaracao_no-select__iGcah`
};
export default ___CSS_LOADER_EXPORT___;
